declare const RELEASE_VERSION: string | undefined;

export const releaseVersion = (): string | undefined =>
  typeof RELEASE_VERSION === 'undefined' ? undefined : RELEASE_VERSION;
